import React from 'react'
import cn from 'classnames'
import ResponsiveImage from '../../ResponsiveImage'
import { theme } from '../../../styles/theme'
import Link from '../../Link'
import { resolveInternalLinkUrl } from '../../../lib/resolveLink'
import { createUseStyles } from '../../../helpers/createStyles'

export default function PostTile ({
  className,
  index,
  post,
  aspect,
  mobileAspect
}) {
  const styles = useStyles()
  const { title, excerpt, featuredImage, category } = post
  const url = resolveInternalLinkUrl(post)
  return (
    <article className={className || null}>
      <Link to={url} className={cn(styles.link)}>
        {featuredImage && (
          <ResponsiveImage
            className={styles.image}
            image={featuredImage}
            aspect={aspect}
            mobileAspect={mobileAspect}
          />
        )}
        <span className={styles.category}>{category?.title}</span>
        <div className={styles.content}>
          <h4 className={styles.title}>{title}</h4>
          <p className={styles.description}>{excerpt}</p>
        </div>
      </Link>
    </article>
  )
}

const useStyles = createUseStyles({
  link: {
    textDecoration: 'none',
    display: 'block'
  },
  image: {
    marginBottom: theme.spacingPx(1)
  },
  category: {
    marginBottom: theme.spacingPx(1),
    opacity: 0.5,
    fontSize: '10px',
    lineHeight: 1.2,
    letterSpacing: '0.12em',
    textTransform: 'uppercase'
  },
  content: {

  },
  title: {
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: 1.4,
    letterSpacing: '0.02em',
    marginBottom: theme.spacingPx(1)
  },
  description: {
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden'
  }
})
